export const getPolygonIdentifiers = (polygonNames: string[]) => {
    return Array.from(polygonNames, (n: string, i: number) => ({
        name: n,
        identifier: n.concat(`-${i}`),
    }));
};
